import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";

const OmniMetricBox = props => {
  const { label, value, bgColor, color, active, onClick } = props;
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));
  return (
    <Grid
      container
      spacing={1}
      onClick={onClick}
      width={"100%"}
      flexWrap={"wrap"}
      paddingTop={"4px"}
      paddingBottom={"4px"}
      paddingLeft={"16px"}
      paddingRight={"16px"}
      backgroundColor={active ? bgColor : theme.palette.grey[500]}
      justifyContent={"space-between"}
      borderRadius={"24px"}
      alignItems={"center"}
      color={color}
      sx={{
        userSelect: "none",
        boxShadow: theme.shadows[1],
        "&:hover": {
          transform: "scale(1.02)",
          filter: "brightness(1.05)",
        },
        "&:active": {
          transform: "scale(.98)",
          filter: "brightness(.95)",
        },
        marginBottom: theme.spacing(1),
      }}
    >
      <Grid>
        <Typography variant={"h6"}>{label}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: "auto", md: 12, lg: "auto" }} textAlign={"end"}>
        <Typography variant={smallScreen ? "h5" : "h6"}>{value}</Typography>
      </Grid>
    </Grid>
  );
};

export default OmniMetricBox;
